import { getCollection } from "@/api/inventory/getConfig";
import { BatchMint } from "@/components/mint/BatchMint";
import { ERC721AMint } from "@/components/mint/ERC721AMint";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/$collection/mint-nft")({
	loader: async ({ params, context }) => {
		const collection = await getCollection({
			queryClient: context.queryClient,
			collectionAddress: params.collection,
		});
		return collection;
	},
	component: MintNFTComponent,
});

function MintNFTComponent() {
	const collection = Route.useLoaderData();

	return collection.type === "ERC721A" ? (
		<ERC721AMint collectionAddress={collection.address} />
	) : (
		<BatchMint collectionAddress={collection.address} />
	);
}
